import Vue from 'vue'
import Vuex from 'vuex'
import { db } from '../firebase'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    contador: 101,
    idGrupo:0,
  },
  mutations: {

  },
  actions: {
    
  },
  modules: {
    
  }
})
